const lineBreaksToNewLine = (text: string) => {
  return text.replace(/<br>/g, '\n');
};

export default lineBreaksToNewLine;
